import React, { useEffect, useRef, useState } from 'react';

import { generatePath, useHistory, useLocation } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import HomeIcon from '@material-ui/icons/Home';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Box } from '@material-ui/core';
import { SERVICES_PROPERTIES } from 'app/config/services';
import { INTERNAL_CONTEXT, URLS } from 'app/config/urls';

import styles from './styles';
import InternalAddNewRequest from 'app/components/InternalAddNewRequest/InternalAddNewRequest';
import MenuDev from '../MenuDev';
import { DEV_ENVIRONMENT } from 'app/utils/constants';
import { clearRequests } from 'app/store/slices/requests';
import helpers from '../../utils/helpers';
import { setIsStrip } from '../../store/slices/line';
import pesquisa from 'app/components/Indecx/pesquisa';
import generalEndpoints from '../../api/services/generalEndpoints';
import { usePersistentFilters } from '../../internalPages/Lines/hooks/usePersistentFilters';

const useStyles = makeStyles(styles);

function InternalHeader() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const request = useSelector(state => state.requests.details);
  const isStrip = useSelector(state => state.line.isStrip);

  let { pathname, search } = location;
  const [path, setPath] = useState([]);
  const isReportPath = useRef(false);

  const [isLineManagerRootPath, setIsLineManagerRootPath] = useState(false);
  const [isManagerRootPath, setIsManagerRootPath] = useState(false);
  const [hideNewRequestInternalButton, setHideNewRequestInternalButton] = useState(null);
  const [hideHomeAndArrow, setHideHomeAndArrow] = useState(null);
  const [cdLinhaFromPath, setCdLinhaFromPath] = useState(null);

  const [linkBack, setLinkBack] = useState(null);
  const [linkHome, setLinkHome] = useState(INTERNAL_CONTEXT);
  const [title, setTitle] = useState('Solicitações');
  const user = useSelector(state => state.auth.user);

  const [ , , , clearAllFilters ] = usePersistentFilters("");

  useEffect(() => {
    (() => {
      let arrPath = pathname.split('/');
      setPath(arrPath);
      setIsLineManagerRootPath(pathname === URLS.LINES_MANAGE);
      setIsManagerRootPath(pathname === INTERNAL_CONTEXT);
      const index = arrPath.findIndex(p => p === 'lines');
      if (arrPath[index + 1] && !isNaN(Number(arrPath[index + 1]))) {
        setCdLinhaFromPath(arrPath[index + 1]);
      }
      let testReportPath = /reports/.test(arrPath[arrPath.length - 1]);
      isReportPath.current = testReportPath;
      setHideNewRequestInternalButton(index >= 0 || isReportPath.current);
      setHideHomeAndArrow(isReportPath.current)
    })();
  }, [pathname]);

  useEffect(() => {
    if (path.includes('strip')) {
      dispatch(setIsStrip(true));
    } else if (search && search !== '') {
      const parsed = helpers.parseQueryString(search);
      const found = parsed.find(entry => {
        return entry.strip;
      });
      if (found) dispatch(setIsStrip(found.strip === 'true'));
    }
  }, [dispatch, search, path]);

  useEffect(() => {
    (() => {
      let tempTitle = 'Solicitações';
      let tempLink = INTERNAL_CONTEXT;
      if (path.includes('lines')) {
        tempLink = URLS.LINES_MANAGE;
      }
      setLinkHome(generatePath(tempLink, { isStrip: isStrip ? 'strip' : undefined }));
      if (path.includes('fares')) {
        if (path.includes('new') || path.includes('edit')) tempLink = URLS.LINES_MANAGE_FARES;
        tempTitle = 'Tarifas';
      } else if (path.includes('itineraries')) {
        if (path.includes('new') || path.includes('edit')) tempLink = URLS.LINES_MANAGE_ITINERARIES;
        tempTitle = 'Itinerário';
      } else if (path.includes('permissionaries')) {
        if (path.includes('new') || path.includes('edit'))
          tempLink = URLS.LINES_MANAGE_PERMISSIONARIES;
        tempTitle = 'Permissionário';
      } else if (path.includes('transfers')) {
        if (path.includes('new') || path.includes('edit')) tempLink = URLS.LINES_MANAGE_TRANSFERS;
        tempTitle = 'Tranferência de Linha';
      } else if (path.includes('schedules')) {
        if (path.includes('new') || path.includes('edit')) tempLink = URLS.LINES_MANAGE_SCHEDULES;
        tempTitle = 'Quadro de Horários';
      } else if (path.includes('conductors')) {
        if (path.includes('new') || path.includes('edit')) tempLink = URLS.LINES_MANAGE_CONDUCTORS;
        tempTitle = 'Condutores Substitutos';
      } else if (path.includes('apostilles')) {
        if (path.includes('new') || path.includes('edit')) tempLink = URLS.LINES_MANAGE_APOSTILLE;
        tempTitle = 'Apostilas';
      } else if (path.includes('contracts')) {
        if (path.includes('new') || path.includes('edit')) tempLink = URLS.LINES_MANAGE_CONTRACT;
        tempTitle = 'Contrato / Termo de Permissão';
      } else if (path.includes('lines')) {
        tempTitle = 'Linhas';
      } else if (isReportPath.current) {
        tempTitle = 'Relatórios';
      }

      const serviceObject = SERVICES_PROPERTIES[request.cdServico];
      if (serviceObject) {
        tempTitle = serviceObject.title;
      }
      setTitle(tempTitle);

      const params = {};
      if (cdLinhaFromPath) params.cdLinha = Number(cdLinhaFromPath);
      if (isStrip) params.isStrip = 'strip';
      setLinkBack(generatePath(tempLink, params));
    })();
  }, [path, request, cdLinhaFromPath, isStrip]);

  //pesquisa de satisfacao - Indecx
  useEffect(() => {
    (async () => {
      const indecxKey = await generalEndpoints.getIndecxKey();
      if (indecxKey && indecxKey.status === 200 && indecxKey.data !== '') {
        const { key, action } = indecxKey.data;
        pesquisa(user, key, action);
      }
    })();
  }, [user]);

  const handleLinkBack = () => {
    if (!isLineManagerRootPath) {
      dispatch(clearRequests());
      if (!linkBack) {
        history.goBack();
      } else {
        history.push(linkBack);
      }
    }
  };

  const goHome = () => {
    clearAllFilters();

    if (history.location.pathname === linkHome) {
      // Forçar o reload caso ja esteja na home para poder renderizar a tela limpa
      window.location.reload();
    } else {
      history.push(linkHome);
    }
  };

  return (
    <Paper elevation={0} className={classes.container}>
      <AppBar elevation={0} position="static" color="default" className={classes.containerHeader}>
        <Toolbar>
          {hideHomeAndArrow ? (
            <Box className={classes.back} style={{cursor: 'default'}}>
              <h2>{title}</h2>
            </Box>
          ) : (
            <>
              <Box onClick={() => goHome()} className={classes.home}>
                <HomeIcon color="secondary" />
              </Box>
              <Box onClick={() => handleLinkBack()} className={classes.back}>
                {!isLineManagerRootPath && !isManagerRootPath && <ArrowBackIcon fontSize='small' color="action" />}
                <h2>{title}</h2>
              </Box>
            </>
          )}
          {!hideNewRequestInternalButton && <InternalAddNewRequest />}
          {process.env.NODE_ENV === 'development' && DEV_ENVIRONMENT && <MenuDev />}
        </Toolbar>
      </AppBar>
    </Paper>
  );
}

export default injectIntl(InternalHeader);
